export default __webpack_public_path__ + "static/media/desktop-bottom-bg.7e0da292.png";